import { Box, Text } from '@mantine/core';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export function PasswordRequirement({
  meets,
  label,
}: {
  meets: boolean;
  label: string;
}) {
  return (
    <Text
      c={meets ? 'var(--mantine-color-otherGreen-0)' : ''}
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 'var(--mantine-spacing-sm)',
      }}
      size="xs"
    >
      {meets ? (
        <CheckIcon style={{ fontSize: 16, marginTop: 2 }} />
      ) : (
        <CloseIcon style={{ fontSize: 16, marginTop: 2 }} />
      )}
      <Box style={{ paddingLeft: 4 }}>{label}</Box>
    </Text>
  );
}
